import React from "react";
import { Loader2, ShieldCheck, X } from "lucide-react";

export function ExportModal({ state, onClose }) {
  if (!state) return null;
  return (
    <div
      className="fixed inset-0 z-[80] grid place-items-center bg-void/80 backdrop-blur-sm"
      data-testid="export-modal"
      onClick={() => !state.busy && onClose()}
    >
      <div className="w-[min(92vw,420px)] rounded-xl border border-edge bg-panel p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3">
          <span
            className={`grid h-9 w-9 place-items-center rounded-lg border ${
              state.busy
                ? "border-aegis-cyan/35 bg-aegis-cyan/10 text-aegis-cyan"
                : "border-aegis-emerald/35 bg-aegis-emerald/10 text-aegis-emerald"
            }`}
          >
            {state.busy ? <Loader2 size={17} className="animate-spin" /> : <ShieldCheck size={17} />}
          </span>
          <p className="flex-1 font-heading text-[15px] text-slate-100" data-testid="export-modal-title">
            {state.title}
          </p>
          {!state.busy && (
            <button onClick={onClose} data-testid="export-modal-close" className="text-slate-400 transition-colors hover:text-aegis-red">
              <X size={16} />
            </button>
          )}
        </div>
        <p className="mt-4 text-[13px] leading-relaxed text-slate-400" data-testid="export-modal-body">
          {state.body}
        </p>
      </div>
    </div>
  );
}
